import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class InstallationStaffPluginService extends InspectionPluginService {
  private staffTypesKeys: any = [
    { value: 1, label: 'plugins.installationstaff.helper' },
    { value: 2, label: 'plugins.installationstaff.mechanical-enginner' },
    { value: 3, label: 'plugins.installationstaff.electrical-enginner' },
    { value: 4, label: 'plugins.installationstaff.maintenance-enginner' },
    { value: 5, label: 'plugins.installationstaff.instructor' },
    { value: 6, label: 'plugins.installationstaff.operator' }
  ];

  private staffTypes: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public applyTranslations() {
    this.staffTypes = [];
    this.copyTranslationValues(this.staffTypesKeys, this.staffTypes, this.language);
  }

  public getStaffTypes() {
    return this.staffTypes;
  }

  public updateStaff(inspectionId: string, pointId: string, pluginId: string, staff: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, staff).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, staff: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, staff).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
